exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".record-image[data-v-33859ea3]{margin-right:1rem}.record-image img[data-v-33859ea3],.record-image svg[data-v-33859ea3]{height:100%;width:100%;object-fit:cover}.record-image .no-image[data-v-33859ea3]{font-size:32px;position:relative;width:100%;padding-top:56.25%}.record-image .no-image>span[data-v-33859ea3]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);

// exports
